/**
 * The invoice api service
 */
import http from "@util/http";
import { core, xxcrm } from "../req";

/**
 * 获取发票列表
 */
export async function queryInvoiceList(params) {
  return http.get(xxcrm.INVOICE_LIST, params);
}

/**
 * 发票使用
 */
export async function queryUseInvoice(params) {
  return http.post(xxcrm.INVOICE_USE, params);
}
export async function queryUseInvoiceEdit(params) {
  return http.post(xxcrm.INVOICE_USE_EDIT, params);
}

/**
 * 添加发票
 */
export async function querySaveInvoice(params) {
  return http.post(xxcrm.INVOICE_SAVE, params);
}

/**
 * 删除发票
 */
export async function queryDeleteInvoice(uuids) {
  return http.get(xxcrm.INVOICE_DELETE, { uuids });
}

/**
 * 作废发票
 */
export async function queryInvalidInvoice(uuids) {
  return http.get(xxcrm.INVOICE_INVALID, { uuids });
}

/**
 * 冲红发票
 */
export async function queryRedInvoice(uuids) {
  return http.get(xxcrm.INVOICE_RED, { uuids });
}

/**
 * 恢复发票
 */
export async function queryRestoreInvoice(uuids) {
  return http.get(xxcrm.INVOICE_RESTORE, { uuids });
}

/**
 * 导出发票
 */
export async function queryExportInvoice(params) {
  http.download(xxcrm.INVOICE_EXPORT, params, '发票导出.xlsx');
}

/**
 * 获取公司列表
 */
export async function queryXxOrg() {
  return http.get(core.XX_ORG_LIST);
}



// WEBPACK FOOTER //
// ./src/api/xxcrm/invoice.js